import React, { useEffect, useRef, useState } from "react";

function extractVideoId(url) {
  const regExp =
    /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;

  const match = url.match(regExp);

  return match && match[2].length === 11 ? match[2] : null;
}

export default function WalkthroughVideo({ virtualDataArray, shouldPlay }) {
  const iframeRef = useRef(null);

  const [videoId, setVideoId] = useState("");

  useEffect(() => {
    const id = extractVideoId(virtualDataArray);

    if (id) setVideoId(id);
  }, [virtualDataArray]);

  useEffect(() => {
    if (!iframeRef.current || !shouldPlay === undefined) return;

    iframeRef.current.contentWindow?.postMessage(
      JSON.stringify({
        event: "command",

        func: shouldPlay ? "playVideo" : "pauseVideo",

        args: [],
      }),

      "*",
    );
  }, [shouldPlay]);

  if (!videoId) return null;

  return (
    <iframe
      ref={iframeRef}
      width="100%"
      src={`
https://www.youtube.com/embed/${videoId}
?enablejsapi=1
&mute=1
&autoplay=1
&loop=1
&playlist=${videoId}
&controls=1
&rel=0
`.replace(/\s/g, "")}
      title="Walkthrough"
      frameBorder="0"
      allow="
      autoplay;
      encrypted-media;
      picture-in-picture
      "
      allowFullScreen
      referrerPolicy="
      strict-origin-when-cross-origin
      "
    />
  );
}
